import React from 'react';
import HeroSection from './HeroSection';
import PropertyTypes from './PropertyTypes';
import PopularDeals from './PopularDeals';
import AboutUs from './AboutUs';
import Counter from './Counter';
import PropertyMediaGallery from './PropertyMediaGallery';
import Testimonial from './Testimonial';
import FeaturedProperties from './FeaturedProperties';
import PropertyBlog from './PropertyBlog';
import Cta from './Cta';
import Footer from '../Layout/Footer';
import PropertyBookModal from './PropertyBookModal';
import RentalProforma from './RentalProforma';


export default function Home() {
  return (
    <>
      <HeroSection/>
      <PropertyTypes/>
      <PopularDeals/>
      <AboutUs/>
      {/* <Counter/> */}
      <PropertyMediaGallery/>
      <Testimonial/>
      <FeaturedProperties/>
      <PropertyBlog/>
      <RentalProforma/>
      <Cta/>
      <Footer/>
      <PropertyBookModal/>
    </>
  )
}
